<template>
  <div class="testimonial-area">
    <div class="container mw-1356">
      <div
        class="testimonial-wrap bg-img pb-100"
        :style="{ backgroundImage: `url(${bgImage})` }"
      >
        <div class="section-title text-center mw-860 m-auto mb-90">
          <h2 class="text-white">ماذا يقول عملاؤنا عن تجربتهم معنا؟</h2>
          <p class="text-white">
            آراء مشتركين حقيقيين وثقوا بخدماتنا، ونحن ملتزمون بتقديم أفضل جودة بث تناسب تطلعاتكم.
          </p>
        </div>

        <div class="position-relative z-1">
          <Swiper
            :slidesPerView="1"
            :spaceBetween="50"
            :centeredSlides="false"
            :preventClicks="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }"
            :navigation="{
              nextEl: '.next',
              prevEl: '.prev',
            }"
            :breakpoints="{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 2,
              },
              1440: {
                slidesPerView: 2,
              },
              1600: {
                slidesPerView: 2,
              },
            }"
            :modules="modules"
            class="testomonial-slide-two"
          >
            <SwiperSlide
              v-for="(testimonial, index) in testimonials"
              :key="index"
            >
              <div class="testimonial-single-item-two">
                <div class="d-flex align-items-center mb-32">
                  <div class="flex-shrink-0">
                    <img :src="testimonial.image" :alt="testimonial.name" />
                  </div>
                  <div class="flex-grow-1 ms-4">
                    <ul
                      class="ps-0 list-unstyled d-flex align-items-center gap-1"
                    >
                      <li v-for="star in 5" :key="star">
                        <i class="ti ti-star-filled"></i>
                      </li>
                    </ul>
                    <h3>{{ testimonial.name }}</h3>
                  </div>
                </div>
                <p>{{ testimonial.review }}</p>
              </div>
            </SwiperSlide>
          </Swiper>

          <div class="testomonial-controller">
            <div class="controller-icon prev">
              <i class="ti ti-arrow-left"></i>
            </div>
            <div class="controller-icon next">
              <i class="ti ti-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";

export default defineComponent({
  name: "OurReviews",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/testimonial-bg.png");
    const testimonials = ref([
      {
        image: require("@/assets/images/testimonial-1.jpg"),
        name: "أحمد العتيبي",
        review:
          "بصراحة السيرفر جبار وثابت جداً خاصة وقت المباريات الكبيرة والقنوات الرياضية. جودة الـ 4K حقيقية وبدون أي تقطيع، والدعم الفني سريع ومحترف في التجاوب الفوري.",
      },
      {
        image: require("@/assets/images/testimonial-2.jpg"),
        name: "خالد المنصوري",
        review:
          "أكثر ما يعجبني هو التحديث المستمر لمكتبة الأفلام والمسلسلات وتوفر جودات متعددة تناسب سرعات الإنترنت المختلفة. أنصح بشدة بالاشتراك معهم، الخدمة ممتازة وتستحق كل يورو.",
      },
      {
        image: require("@/assets/images/testimonial-1.jpg"),
        name: "يوسف الهادي",
        review:
          "جربت سيرفرات كثيرة سابقاً ولكن هذا السيرفر تفوق عليها بالثبات وسهولة التنقل بين القنوات ودليل البرامج المفصل. الدعم الفني ساعدني في تشغيله على شاشتي خلال دقائق معدودة.",
      },
      {
        image: require("@/assets/images/testimonial-2.jpg"),
        name: "عمر الفاروق",
        review:
          "خدمة ممتازة وسيرفر ثابت ومستقر للغاية أثناء البث المباشر. تقسيم الباقات رائع، وميزة التجديد اليدوي بدون سحب تلقائي تمنح أماناً وراحة كبيرة في التعامل.",
      },
    ]);

    return {
      modules: [Autoplay, Navigation],
      testimonials,
      bgImage,
    };
  },
});
</script>